<form [formGroup]="form">
    <mat-form-field appearance="outline"  >
        <mat-label>{{ label|translate}}</mat-label>
        <mat-select disableOptionCentering="true" formControlName="productId" (selectionChange)="onClick()">
            <mat-option value="" selected> {{'Common.Choose'|translate}} </mat-option>
            <mat-option class="theme-select" *ngFor="let item of dataSource" (click)="onChoose(item)"
                [value]="item.Id">
                @if (showNameEn) {
                    {{ item.NameEn }}
                }@else {
                     {{ item.Name }}
                }
            </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('productId')?.errors?.['required']">
            {{ 'Common.RequiredField' | translate }}
        </mat-error>
    </mat-form-field>
</form>